export default (function (_ref) {
  var request = _ref.request;
  return {
    regionalSalesAdd: function regionalSalesAdd(data) {
      return request({
        url: '/mng/regionalSales/add',
        method: 'post',
        data: data
      });
    },
    regionalSalesModify: function regionalSalesModify(data) {
      return request({
        url: "/mng/regionalSales/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    regionalSalesDel: function regionalSalesDel(id) {
      return request({
        url: "/mng/regionalSales/".concat(id, "/del"),
        method: 'delete'
      });
    },
    regionalSalesQuery: function regionalSalesQuery(data) {
      return request({
        url: '/mng/regionalSales/query',
        method: 'get',
        params: data
      });
    },
    regionalSalesDetail: function regionalSalesDetail(id) {
      return request({
        url: "/mng/regionalSales/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});